import React, {useContext,useEffect,useState} from 'react'
import { useNavigate } from "react-router-dom";

import Button from 'react-bootstrap/Button';
import "bootstrap/dist/css/bootstrap.min.css";
import cross from '../../images/cross.png'
import '../../components/css/editModal.css'
import eye from '../../images/Icon-Eye-2023.png'
import small_square from '../../images/small_square.svg'
import small_checkmark from '../../images/small_checkmark.svg'
import { keyContext } from '../KeyContext'
import Modal from './Modal'
// import editCross from '../images/editcross.png'
// import white_arrow from '../images/White Arrow PNG.jpg'
import alertIcon from '../../images/Icon-Altert_Small.png';


function EditModal({ children, shown, close, movie_name, sal_nr,dato,start_time,end_time,  the_Event, color1, color2, all_events }) {

  const {leftMargin,arrTypes, allTicketTypes,setEventSaveObj, setShowErrorModal, setErrorNo, setErrorText,eventSaveObj,setErrorStatus,setErrorType,setApiLoader,setWaitingModal,logOut,eventPushCheck} = useContext(keyContext)

    const navigate = useNavigate();
  
   let flag = false // flag determines overlap text when api takes more than 2 seconds to reply

  const [updatedPG, setUpdatedPG] = useState([]);
  const key = sessionStorage.getItem("key");
   const [newEvent, setNewEvent] = useState();
 
  let theEvent = newEvent ? newEvent : the_Event
  let ticketTypesOriginal 

 all_events.map((ev) => {
  if(theEvent.No > 0 && theEvent.No === ev.No) {
   
    ticketTypesOriginal = ev
  }
  return ticketTypesOriginal
 })


  // const [theEvent, setTheEvent] = useState(newEvent ? newEvent : the_Event);
  // eventSaveObj?.No === theEvent.No ? eventSaveObj.PriceGroups :
  let priceGroups =   theEvent.PriceGroups
   const [priceGroupsWithRule, setPriceGroupsWithRule ] =   useState([])
  let priceGroups2 = all_events.find((ev) => {return ev.No === theEvent.No})?.PriceGroups
  const [priceChange, setPriceChange] = useState(false);

 
  // console.log(theEvent, 'the event')
  
  // const clientHeight = shown ?  document.getElementById('tes').clientHeight : ''
  // const [arrtypeSelect,setArrtypeSelect] = useState(false)
  // const [btnDisable, setBtnDisable] = useState(false);
  // const [newTicketTypesArr, setNewTicketTypesArr] = useState([])
 
  const [tktDetailShown, SetTktDetailShown] = useState(true);
  const [priceRule, setPriceRule] = useState();
  const [tickettypeRule, setTickettypeRule] = useState();
  
  const ticketTypesRemove =   theEvent?.TicketTypes_Remove?.length ? theEvent.TicketTypes_Remove : []
  const ticketTypesAdd = theEvent?.TicketTypes_Add?.length ? theEvent.TicketTypes_Add : []
  
  const [arrtypeName, setArrtypeName] = useState(theEvent?.ArrTypeName)
  const [ticketTypes,setTicketTypes] = useState(theEvent.TicketTypes)
  // const [ticketTypesFromTicketRule, setTicketTypesFromTicketRule] = useState([]);



  // useEffect(() => {
  //   if(newTicketTypesArr) setTicketTypes(newTicketTypesArr)
  // }, [newTicketTypesArr]);


  // useEffect(() => { 
  //   if(allTicketTypes.length < 51 ) {
  //     setBtnDisable(true)
  //   }
  // }, [allTicketTypes]);

    let chosedTicketTypes      = []
    let notChosedtickettypes   = []
    let chosedTktTypesWithRule = []
    
   
     let total_tks =  ticketTypesAdd.length && theEvent.TicketTypes ? theEvent.TicketTypes?.concat(ticketTypesAdd) : theEvent.TicketTypes && !ticketTypesAdd.length ? theEvent.TicketTypes  : ticketTypesAdd
    
    
    total_tks.map((tkt) => {
      allTicketTypes.map(tk => {
        if(tk.No === tkt.No ) {

          chosedTicketTypes.push(tk)
        } 
      
      })
       
    })

    // useEffect(() => {
      theEvent.TicketTypes?.map((tkt) => {
        allTicketTypes.map(tk => {
          if(tk.No === tkt.No ) {
          
          //  setChosenTicketsWithRule(tk)
          chosedTktTypesWithRule.push(tk)
          } 
        
        })
         
       })

//const [chosenTicketsWithRule, setChosenTicketsWithRule] = useState(chosedTktTypesWithRule);

    const total_slides_with_details = Math.ceil(allTicketTypes.length/50)
    const total_slides_no_details = Math.ceil(allTicketTypes.length/100)
    

    const numberOfSlides = []
    const four_row_slides = []
    const total_slides = tktDetailShown === true ?  total_slides_with_details : total_slides_no_details
   
     for (let index = 0; index < total_slides; index++) {
     
     numberOfSlides.push(index);
    
  }
   for (let index = 0; index < total_slides_no_details; index++) {
     
     four_row_slides.push(index);
    
  }
 
  
 const result =ticketTypesRemove[0]?.No && chosedTicketTypes.filter(x => {
       return !ticketTypesRemove.some(t => t.No === x.No);
  })
 chosedTicketTypes =  result?.length ? result : chosedTicketTypes

    const [chosenTickets, setChosenTickets] = useState(chosedTicketTypes)


    notChosedtickettypes = allTicketTypes.filter(x => { 
      return !chosedTicketTypes.some(t => t.No === x.No)
    })
    // adding the tickets from notchosen to chosen if tickets are under add array
 const result_Add = ticketTypesAdd[0]?.No && notChosedtickettypes.filter(x => {
  return !ticketTypesAdd.some(t => t.No === x.No);
})
notChosedtickettypes = result_Add?.length ? result_Add : notChosedtickettypes


  
    
    const [notChosenTickets, setNotChosenTickets] = useState(notChosedtickettypes)

   
      // following function for alert icon on chosen ticket types
    function checkForAlertonChosen (item) {
    
      let showAlert    
      ticketTypesAdd.length > 0 && ticketTypesAdd.map(tr => {
        
        if (tr.No === item.No) {
            showAlert= true
         return showAlert
        }      
       })    
      return showAlert
   }
  // following function for alert icon on not chosen ticket types
   function checkForAlertonNotChosen (item) {
    let showAlert 
    ticketTypesRemove[0]?.No && ticketTypesRemove.map(tr => {
      if (tr.No === item.No) {
          showAlert= true
       return showAlert
      }  
     }) 
    return showAlert
 }
      // ----search functionality------
  const [q, setQ ] = useState('')   // search word for arrtypes
  const [b,setB ] = useState('')   // search word for tickettypes
  const [searchParam] = useState(["Name"]);
  const [filterParam, setFilterParam] = useState(["Name"]);
  
   
  function search(items) {
    return items.filter((item) => {
     
        if (filterParam == "Name") {
            return searchParam.some((newItem) => {
                return (
                  item[newItem] && item[newItem]
                        .toString()
                        .toLowerCase()
                        .indexOf(q || b.toLowerCase()) > -1
                );
            });
        }
    }); 
  }

  function selectArrType (e) {
    setQ(e.target.innerText)
    // setArrtypeSelect(true)
  }

function deleteArrType () {

  theEvent.ArrTypeName = ''
  theEvent.ArrTypeNo=0
  setWaitingModal(true)

  fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_save` ,{
    method: "POST",
   
   headers: {
    'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
    'Content-Type':  'application/x-www-form-urlencoded',
    
   },
 
   body:`Key=${key}&eventdata=${JSON.stringify(theEvent)}`
   
})
 .then(res =>  { 
        flag =  true
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
.then(result => { 
  
        setWaitingModal(false)
        
         setApiLoader(false)
     if(result.Result === 1) {
          theEvent=result
          setEventSaveObj(result)
        }
          else if (result.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
          else if(result.Result === -1) {
         //   console.log('call event push check')
            eventPushCheck()
          }
        else {
          setShowErrorModal(true)
          setErrorNo(result.Result)
          setErrorText(result.ErrorDescription)
        }

})
 setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
            console.log('did not get response in 2 seconds')
            
          } 
         }, 2000)
   setArrtypeName('')
   setQ('')
   setarrtypechange(false)
}

const [firstPrice, setFirstprice] = useState()
const [lastPrice, setLastprice] = useState()


useEffect(() => {
  let prices = priceGroups?.sort((a,b) => a.Price > b.Price ? 1 : -1)
  setFirstprice(priceGroups?.sort((a,b) => a.Price > b.Price ? 1 : -1)[0])
  setLastprice(prices && prices[prices.length - 1])
 
},[priceGroups])


/**-----calculating price per kroner */
function calculatePrice (type) {

 let price 
 if(type.PriceType === 1) {
     price = type.Price
 }
 if(type.PriceType === 2) {
   price = type.AddPrice > 0 ? '+'+type.AddPrice : type.AddPrice
 }
 if(type.PriceType === 8) {
  price= type.ProPrice+'%'
 }
 if(type.PriceType === 0) {
    
   price = priceGroups?.length > 1 ? `${firstPrice.Price}/${lastPrice.Price}` : priceGroups && priceGroups[0]?.Price
  }

 return price
}


const [objToTransfer, setObjToTransfer] = useState()
//  const [ticketNo,setTicketNo] = useState()
const [clickedNo, setClickedNo] = useState()



function eventSaveRemove (tickettype) {

  // if No already exixts in ticketTypes ADD then remove it from ticketTypes_Add
  theEvent.TicketTypes_Add !== null &&   theEvent.TicketTypes_Add !== '' && theEvent.TicketTypes_Add.some(el => el.No === tickettype?.No) ?
  theEvent.TicketTypes_Add=  theEvent.TicketTypes_Add?.filter(e => e.No !== tickettype?.No)
 
: (
  ticketTypesRemove[0] ?   
  theEvent.TicketTypes_Remove.push({No:tickettype.No}) 
: theEvent.TicketTypes_Remove =  [{No:tickettype.No}]   // before it was removes
)
   
    setWaitingModal(true)
  
   fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_save` ,{
    method: "POST",
   
   headers: {
    'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
    'Content-Type':  'application/x-www-form-urlencoded',
    
   },
 
   body:`Key=${key}&eventdata=${JSON.stringify(theEvent)}`
   
})
 .then(res =>  { 
            flag =  true
    
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
.then(result => { 
        setWaitingModal(false)
        
         setApiLoader(false)
           
    if(result.Result === 1) {
        theEvent=result
        setEventSaveObj(result)
    }
     else if (result.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
          else if(result.Result === -1) {
         //   console.log('call event push check')
            eventPushCheck()
          }
    else {
      setShowErrorModal(true)
      setErrorNo(result.Result)
      setErrorText(result.ErrorDescription)
    }
 

})
       setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
            console.log('did not get response in 2 seconds')
            
          } 
         }, 2000)

}

function eventSaveAdd (tickettype) {
 
  // ONLY ADD TO THE tickettypes_add if its not already exists in tickettypes
   if(chosenTickets.includes(tickettype) === false) { 
     // if the tickettype we trying to add exists in tickettypes_remove then remove it from the tickettype_remove
      theEvent.TicketTypes_Remove !== null && theEvent.TicketTypes_Remove !== '' &&  theEvent.TicketTypes_Remove.some(el => el.No === tickettype?.No) ?
      theEvent.TicketTypes_Remove =  theEvent.TicketTypes_Remove?.filter(e => e.No !== tickettype?.No)
  :
  
   (
  ticketTypesAdd[0] ?   
  
       theEvent.TicketTypes_Add.push({No:tickettype.No}) 
 
     : theEvent.TicketTypes_Add = [{No:tickettype.No}]  

  )

    setWaitingModal(true)
   fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_save` ,{
    method: "POST",
   headers: {
    'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
    'Content-Type':  'application/x-www-form-urlencoded',   
   },
   body:`Key=${key}&eventdata=${JSON.stringify(theEvent)}` 
})
 .then(res =>  { 
            flag =  true
    
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
.then(result => { 
        setWaitingModal(false)
        setApiLoader(false)
    if(result.Result === 1) { 
      theEvent=result
      setEventSaveObj(result)
    }
     else if (result.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
    else if(result.Result === -1) {
          //  console.log('call event push check')
            eventPushCheck()
          }
    else {
      setShowErrorModal(true)
      setErrorNo(result.Result)
      setErrorText(result.ErrorDescription)
    }

})
  setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
            console.log('did not get response in 2 seconds')
            
          } 
         }, 2000)
   }
}


 function handleChosenTicketSelect(ticket) {     
  
        setObjToTransfer(ticket)
        // if ticket already exists in chosentickets then remove it and call eventsaveremove else add it and call eventsaveadd
        if(chosedTicketTypes.includes(ticket) === true) {       
           let newarr = chosedTicketTypes.filter((item) => item !== ticket)
           setChosenTickets(newarr)
           eventSaveRemove(ticket)
        }
        else {         
          let added = [...chosedTicketTypes, ticket]         
         
          setChosenTickets(added)
          eventSaveAdd(ticket)
         }
               
}


const [arrtypechange, setarrtypechange] = useState(false);

function handleArrtypeChange (e,) {
setQ(e.target.value.toLowerCase())
setarrtypechange(true)


}

useEffect(() => {
  let newArrtype = arrTypes.find(arr => { return arr.Name === q})
 
  // all_events.map((ev) => {
  //   if(ev.No === theEvent.No) {
      if(newArrtype) { 
        // if(theEvent.No === )
      theEvent.ArrTypeName = newArrtype.Name
      theEvent.ArrTypeNo = newArrtype.No
    
        eventSave(theEvent)
    }
  //   }
  // })
  
//  setArrtypeSelect(true)
},[q])

// const [priceChange2, setPriceChange2] = useState(false);
// const [priceChange3, setPriceChange3] = useState(false);
// const [priceChange4, setPriceChange4] = useState(false);
// const [priceChange5, setPriceChange5] = useState(false);



 function handlePriceChange (e,index,elm) {
  e.target.placeholder=''
  
  theEvent.PriceGroups.map((item) => {
       if(item.No === elm.No ) {
        item.Price = Number(e.target.value)
        eventSave(theEvent)
       
       }
  })
  setPriceChange(true)
  
 }


const [eventEdit, setEventEdit] = useState(false);  // which is true/False in theEvent

useEffect(() => {
if(theEvent.RefNo > 0) {
  setEventEdit(true)
}

}, [theEvent]);

 useEffect(() => {
  theEvent.eventEdit = eventEdit
 }, [theEvent,eventEdit]);




// api call to event save
function eventSave (theEvent) {
    setWaitingModal(true)

  fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_save` ,{
    method: "POST",
   
   headers: {
    'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
    'Content-Type':  'application/x-www-form-urlencoded',
    
   },
 
   body:`Key=${key}&eventdata=${JSON.stringify(theEvent)}`
   
})
  .then(res =>  { 
            flag =  true
    
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
 .then(result => { 
        setWaitingModal(false)
        setApiLoader(false)
     if(result.Result === 1) {   
   
        theEvent = result
        theEvent.PriceGroups = result.PriceGroups
        theEvent.TicketTypes = result.TicketTypes
         setNewEvent(result)
        setEventSaveObj(result)
        setTicketTypes(result.TicketTypes)
       
        setPriceGroupsWithRule(result.PriceGroups)
        priceGroups = result.PriceGroups
        // result.UseTicketTypeTemplate === 1 && setTicketTypesFromTicketRule(result.TicketTypes)

    }
     else if (result.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
    else if(result.Result === -1) {
          //  console.log('call event push check')
            eventPushCheck()
          }
    else {
    setShowErrorModal(true)
    setErrorNo(result.Result)
    setErrorText(result.ErrorDescription)
  }

})
   setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
            console.log('did not get response in 2 seconds')
            
          } 
         }, 2000)
setEventEdit(true)
// theEvent= newEvent
theEvent.eventEdit= eventEdit
}

const [slide_index, setSlide_index] = useState(0);


function handleDetailView () {
SetTktDetailShown((current => !current))
setSlide_index(0)
}






 useEffect(() => {
  if(shown === true) { 
      showSlides(slide_index);

     }
    
 },[slide_index,shown])

 
function backSlide(e) {
    e.preventDefault();

           setSlide_index((val) => {
            // console.log(val, 'val')
     
        return val - 1;
      
    });
}

function nextSlide(e) {
    e.preventDefault();

       setSlide_index((val) => {
      if (val >= numberOfSlides.length - 1) {
        return 0;
      } else {
        return val + 1;
      }
    });
}



function showSlides(n) {
  let slides = document.getElementsByClassName("mySlides");

  let i;
 
  
 
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";  
  }
 
  
   slides ? slides[slide_index].style.display = "block" :  slides[slide_index].style.display = 'none'
  
}
const [priceRuleClicked,   setPriceRuleClicked]   = useState(false);
const [ticketRuleClicked, setTicketRuleClicked]   = useState(false);

useEffect(() => {
  setPriceRule(theEvent.UsePriceGroupTemplate === 1 ? true : false   )
  setTickettypeRule(theEvent.UseTicketTypeTemplate === 1 ? true : false)
}, [theEvent]);


function handlePriceRule () {
  if(theEvent.UsePriceGroupTemplate === 1 ) {
    theEvent.UsePriceGroupTemplate = 0
  }
  else theEvent.UsePriceGroupTemplate = 1

  eventSave(theEvent)
  setPriceRule((current) => !current)
  setPriceRuleClicked((current) => !current)
  
}


function handleTicketRule () {
  
  if(theEvent.UseTicketTypeTemplate === 1) {
    theEvent.UseTicketTypeTemplate = 0
    if( ticketTypesOriginal )  theEvent.TicketTypes = ticketTypesOriginal.TicketTypes
 
  }
  else {
    theEvent.UseTicketTypeTemplate = 1
    theEvent.TicketTypes_Add?.length > 0 ? theEvent.TicketTypes_Add = null :  theEvent.TicketTypes_Add = ''
    theEvent.TicketTypes_Remove?.length > 0 ? theEvent.TicketTypes_Remove = null : theEvent.TicketTypes_Remove = ''


  }

  eventSave(theEvent)
  setTickettypeRule((current)  => !current)
  setTicketRuleClicked((current)  => !current)
 
}



// price rule alert check
function priceRuleAlert(event) {
  let alert
  all_events.map((ev) => {
    if(ev.No === event.No) {
       if(ev.UsePriceGroupTemplate !== event.UsePriceGroupTemplate) {
          alert= true
          return alert
           }
        }
})
return alert
}

// ticket rule alert check
function ticketRuleAlert (event) {
  let alert
  all_events.map((ev) => {
     if(ev.No === event.No) {
        if(ev.UseTicketTypeTemplate   !== event.UseTicketTypeTemplate) {
            alert = true
            return alert
        }   
    }
})
return alert
}

// alrt icon check when price changed
function checkingAlert (elm) {
 
  let alert
  
priceGroups2 && priceGroups2.map((pg) => {
  if(pg.No === elm.No ) {
    if(elm.Price !== pg.Price) {
  
      alert = true
    
    }
  }
})
return alert
}

// alrt icon check when arrtype changed
// const [arrtypeAlert, setarrtypeAlert] = useState(false);
function arrtypeAlert (event) {
  let alert
  all_events.map((ev) => {
    if(ev.No === event.No) {
       if(ev.ArrTypeNo  !== event.ArrTypeNo ) {
        alert = true
        return alert
       }
     
    }
  })
  return alert
}

const windowHeight = window.innerHeight

useEffect(() => {
   if(theEvent.UsePriceGroupTemplate === 1) {
    setUpdatedPG(priceGroupsWithRule.length > 0 ? priceGroupsWithRule : priceGroups)
   }
   else 
   setUpdatedPG(theEvent.PriceGroups)
}, [theEvent,priceRuleClicked,priceGroupsWithRule,priceGroups]);

  let tktCount = 0;



  return  shown ?  (
    <Modal open={shown} > 
    <div>
            <div 
           
              //className="modal-content"
              onClick={e => {
                // do not close modal if anything inside modal content is clicked
                e.stopPropagation();
              }}
            >
             {children}
          
          <section className='modalContainer' style={{backgroundColor:color1, border:'1px solid var(--Red, #982F2F)',borderRadius:'9px',width:'1176px',position:windowHeight> 1000 ?'absolute':'',top:windowHeight> 1000 ? '50%' : '69px',left:windowHeight > 1000 ? '50%': '',transform: windowHeight > 1000 ? 'translate(-50%,-50%)':''}}>
              <div className='modal_title'    style={{backgroundColor:'rgba(0,0,0,0.1)',position:'relative'}}>
                <span style={{marginRight:'40px',}}>{movie_name}</span>
                <span style={{marginRight:'40px'}}>{sal_nr}</span>
               
                <span>kl. {start_time} - {end_time}</span>
                <span  onClick={() => {
                   // close modal when outside of modal is clicked
                   close();
                   }} style={{float:'right',position:'absolute',right:'15px',cursor:'pointer',top:'6px'}}>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.24422 6.47669C7.16425 6.39984 7.11993 6.29825 7.11993 6.19021C7.11993 6.08127 7.16472 5.9788 7.24586 5.90172L9.35649 3.89654C9.364 3.88963 9.36916 3.88139 9.37596 3.87404L11.8053 1.56633C12.0649 1.31972 12.0649 0.919848 11.8053 0.673238C11.5457 0.426629 11.125 0.426629 10.8651 0.673238L8.4386 2.97827C8.42875 2.98673 8.41749 2.99297 8.40811 3.0021L6.29701 5.00684C6.14176 5.15409 5.89834 5.16322 5.72996 5.03825L1.13488 0.673238C0.875268 0.426629 0.454548 0.426629 0.194706 0.673238C-0.0649019 0.919848 -0.0649019 1.31972 0.194706 1.56633L2.60294 3.85399C2.6149 3.86735 2.62451 3.88183 2.63765 3.89431L4.74851 5.89971C4.82965 5.97657 4.87445 6.07904 4.87445 6.18798C4.87445 6.29669 4.82965 6.39917 4.74851 6.47625L2.63765 8.48142C2.62451 8.4939 2.6149 8.5086 2.60294 8.52175L0.194706 10.8094C-0.0649019 11.056 -0.0649019 11.4559 0.194706 11.7025C0.324627 11.8259 0.49465 11.8874 0.664908 11.8874C0.834931 11.8874 1.00519 11.8259 1.13488 11.7025L3.57219 9.38722C3.57688 9.38299 3.58227 9.38031 3.58673 9.37608L5.69783 7.37112C5.86551 7.21206 6.13778 7.21206 6.30546 7.37135L8.41656 9.37675L10.8651 11.7025C10.995 11.8259 11.1651 11.8874 11.3353 11.8874C11.5054 11.8874 11.6756 11.8259 11.8053 11.7025C12.0649 11.4559 12.0649 11.056 11.8053 10.8094L7.24422 6.47669Z" fill="#282828"/>
                  </svg>
              </span>
              </div> 
              
              <div className='modal_desc'>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',marginRight:'30px',minHeight:'150px'}}>
             {/* <div> */}
                 <div style={{paddingLeft:'30px',paddingTop:'25px'}}>
                  <div style={{width:'278px',display:'flex',justifyContent:'space-between',margin:0,padding:0}}>
                      <p style={{fontWeight:'bold',height:'15px',letterSpacing:'0.32px',color:color2}}>Prisgrupper</p>
                      <div style={{fontSize:'12px',width:'149px',marginTop:'5px'}}> 
                        <img onClick={handlePriceRule} src={priceRule === false ? small_square : small_checkmark} alt='checkbox'/> Brug prisgrupperegler 
                        {priceRuleAlert(theEvent) === true || priceRule === true ?  <img src={alertIcon} style={{marginLeft:'3px'}} alt='alert-icon'/> : ''}
                      </div>
                  </div>                 
                  <div style={{width:'200px',display:'flex',justifyContent:'space-between',fontSize:'12px',margin:0,padding:0}}>
                      <div style={{}}>
                         <p style={{height:'5px',fontWeight:'bold'}}>Navn</p>

                       </div>
                      <div>
                        <p style={{height:'8px',fontWeight:'bold',width:'73px'}}>Pris kr.</p>
                        
                      </div>                        
                    </div>
                                      
                    {updatedPG?.map((elm,index) => {
                      return <div key={index} style={{width:'200px',display:'grid',gridTemplateColumns:'2fr 1fr',fontSize:'12px',margin:0,padding:0,height:'19px',position:'relative'}}>
                        <div>
                          <p className='text_elip'>{elm.Name}</p>
                        </div>
                        <div style={{marginTop:'3px'}}> 
                          <input disabled={theEvent.UsePriceGroupTemplate === 1 ? true : false} type='text' style={{width:'73px',height:'14px',display:'block',marginBottom:'3px',textAlign:'right'}} placeholder={elm.Price} onChange={(e)=>handlePriceChange(e,index,elm)} />
                        </div>
                      
                        { checkingAlert(elm) === true  ? <img src={alertIcon} alt ='alert-icon' style={{height:'12px',marginTop:'4px',marginLeft:'4px',position:'absolute',right:'-15px'}}/> : ''}

                      </div>
                    })}
                   
                 </div>
                 <div>
                 <div style={{paddingTop:'25px',position:'relative',left:'40px'}}>
                  <p style={{fontWeight:'bold',letterSpacing:'0.32px',color:color2,height:'12px'}}>Forestillingtype</p>
                  <input  name="" id=""  value={q?q:arrtypeName}
                            onChange={(e) =>handleArrtypeChange(e) } style={{width:'500px',paddingLeft:'30px',height:'32px'}} />                    
                  <div style={{border: q &&  search(arrTypes) ? '1px solid #8b8b8b' : '1px',backgroundColor:'white',position:'absolute',right:'74px',left:0,zIndex:1}}> 
                 { q && search(arrTypes).map((item) => (
                     
                       <p style={{padding:0,margin:0,paddingLeft:'10px',fontSize:'12px'}} 
                       onClick={ (e) => selectArrType(e)}>{item.Name}</p>                                           
                    )
                    )}   
                  </div>
                
                <span style={{position:'absolute', top:'56px',left:'8px'}}>
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.8709 15.4795L11.8948 11.5157C12.9783 10.1946 13.5111 8.50888 13.3828 6.8072C13.2546 5.10553 12.4751 3.51809 11.2058 2.37324C9.93639 1.22839 8.27418 0.613723 6.56295 0.656377C4.85172 0.699031 3.2224 1.39574 2.012 2.6024C0.801605 3.80906 0.102734 5.43335 0.059948 7.13929C0.017162 8.84523 0.633734 10.5023 1.78213 11.7678C2.93053 13.0332 4.52288 13.8102 6.22984 13.9381C7.93679 14.0659 9.62773 13.5348 10.9529 12.4547L14.929 16.4185C15.0546 16.5394 15.2229 16.6064 15.3975 16.6048C15.5722 16.6033 15.7393 16.5335 15.8628 16.4104C15.9863 16.2872 16.0563 16.1207 16.0578 15.9466C16.0594 15.7725 15.9922 15.6047 15.8709 15.4795ZM6.74038 12.6287C5.68641 12.6287 4.65611 12.3171 3.77977 11.7333C2.90342 11.1496 2.2204 10.3199 1.81706 9.34917C1.41373 8.37844 1.3082 7.31027 1.51382 6.27975C1.71943 5.24923 2.22697 4.30263 2.97224 3.55967C3.7175 2.8167 4.66703 2.31074 5.70075 2.10575C6.73446 1.90077 7.80594 2.00597 8.77968 2.40806C9.75342 2.81015 10.5857 3.49107 11.1712 4.3647C11.7568 5.23834 12.0693 6.26545 12.0693 7.31616C12.0677 8.72464 11.5058 10.075 10.5068 11.0709C9.50773 12.0669 8.15321 12.6271 6.74038 12.6287Z" fill="#323232"/>
</svg>
                  {/* <img src={searchimg} alt='search' height='20px'/> */}
                </span>
                <span style={{position:'absolute',right:'78px',top:'56px'}}>
                 { (q  || arrtypeName) &&   <img src={cross} alt="" onClick={deleteArrType}/> }
                </span>     
                {arrtypeAlert(theEvent) === true || arrtypechange === true ? <img style={{marginLeft:'5px'}} src={alertIcon} alt= 'alert-icon'/> : ''}        
                 </div>
               
                 </div>
<br />

</div>
<br />

                 <div>
                 <div style={{left:'30px ',position:'relative',width:'500px',}}>
                  <p style={{fontWeight:'bold',height:'12px',letterSpacing:'0.32px',color:color2}}>Billettyper</p>
                  <input type="search" name="" id="search_input" style={{paddingLeft:'30px',width:'100%',height:'32px'}} value={b} onChange={(e) => setB(e.target.value)} placeholder='Søg'/>
                  
              <span>
                <span style={{position:'absolute', top:'32px',left:'8px'}}>
                  {/* <img src={searchimg} alt='search' height='20px'/> */}
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.8709 15.4795L11.8948 11.5157C12.9783 10.1946 13.5111 8.50888 13.3828 6.8072C13.2546 5.10553 12.4751 3.51809 11.2058 2.37324C9.93639 1.22839 8.27418 0.613723 6.56295 0.656377C4.85172 0.699031 3.2224 1.39574 2.012 2.6024C0.801605 3.80906 0.102734 5.43335 0.059948 7.13929C0.017162 8.84523 0.633734 10.5023 1.78213 11.7678C2.93053 13.0332 4.52288 13.8102 6.22984 13.9381C7.93679 14.0659 9.62773 13.5348 10.9529 12.4547L14.929 16.4185C15.0546 16.5394 15.2229 16.6064 15.3975 16.6048C15.5722 16.6033 15.7393 16.5335 15.8628 16.4104C15.9863 16.2872 16.0563 16.1207 16.0578 15.9466C16.0594 15.7725 15.9922 15.6047 15.8709 15.4795ZM6.74038 12.6287C5.68641 12.6287 4.65611 12.3171 3.77977 11.7333C2.90342 11.1496 2.2204 10.3199 1.81706 9.34917C1.41373 8.37844 1.3082 7.31027 1.51382 6.27975C1.71943 5.24923 2.22697 4.30263 2.97224 3.55967C3.7175 2.8167 4.66703 2.31074 5.70075 2.10575C6.73446 1.90077 7.80594 2.00597 8.77968 2.40806C9.75342 2.81015 10.5857 3.49107 11.1712 4.3647C11.7568 5.23834 12.0693 6.26545 12.0693 7.31616C12.0677 8.72464 11.5058 10.075 10.5068 11.0709C9.50773 12.0669 8.15321 12.6271 6.74038 12.6287Z" fill="#323232"/>
</svg>
                  </span>
              </span>

                 </div>
                 <div style={{marginLeft:'30px',marginTop:'40px',  display:'flex',justifyContent:'space-between',width:'320px'}}>
                      <p style={{fontWeight:'bold',height:'18px',letterSpacing:'0.32px',color:color2,fontSize:'16px',}}>Overblik</p>
                      <div style={{fontSize:'12px',marginTop:'5px'}}> 
                        <img onClick={ handleDetailView} src={tktDetailShown === true ?  small_checkmark : small_square} style={{paddingTop:'2px',paddingRight:'8px'}} alt='checkmark'/> 
                      Vis detaljer </div>            
                      <div  style={{fontSize:'12px',marginTop:'5px'}}><img onClick={handleTicketRule}
                      src={tickettypeRule === false ?  small_square : small_checkmark} alt="" /> Brug billettyperegler
                        {ticketRuleAlert(theEvent) === true || tickettypeRule === true ?  <img src={alertIcon} style={{marginLeft:'3px'}} alt='alert-icon'/> : ''}
                      
                      </div>
                 </div>
                 {/* billetype div ends above */}


<div className='slideshow-container' >            
        {numberOfSlides.map((slide) => (
       
          <> 
          <div className='mySlides fades'> 
              <div  style={{border:'1px ', display:'flex',padding:'0px 30px'}}>
             {/* div 1 */}          
                  <div style={{marginRight:'35px'}}>                      
                  <div style={{display:'grid',width:tktDetailShown === true ?'500px':'250px',fontSize:' 12px',fontWeight:'bold',marginTop:'20px',gridTemplateColumns: tktDetailShown === true ? '0.7fr .4fr .4fr .24fr .2fr' : '.1fr 1fr',height:'20px',letterSpacing:'0.24px'}}>
                   <p style={{fontWeight:'bold',paddingLeft:'0px'}}>Tilføjet</p>
                   { tktDetailShown === true ?
                   <>
                   <p style={{fontWeight:'bold',textAlign:'center',width:'78px'}}>Website</p>
                   <p style={{fontWeight:'bold',width:'72px',textAlign:'center'}}>Bundlesalg</p>
                   <img style={{paddingRight:'20px'}} src={eye} alt="" />
                   <p style={{fontWeight:'bold'}}>Pris kr.</p> 
                   </>
                   : ''}
                  </div>              
                  <div style={{border:'1px solid #8b8b8b',
                    width:tktDetailShown === false ? '250px':'535px',height:'463px',marginBottom:'0px',backgroundColor:'white',overflow:'auto',padding:'5px'}}>
                  
                 {b ? 
                  search(allTicketTypes).map((tkt) => (
                   <div  style={{display:'grid',
                   gridTemplateColumns: tktDetailShown === true ? '0.1fr 0.7fr .4fr .4fr .2fr .3fr .1fr' : '.11fr 1fr .1fr',fontSize:'12px',backgroundColor:clickedNo === tkt.No ? '#982f2f' : '',color:clickedNo === tkt.No ? 'white' : ''}} onClick={(e) =>theEvent.UseTicketTypeTemplate === 0 ?  handleChosenTicketSelect(e,tkt) : ''}>
                     
                  <img style={{padding:'2px',filter: theEvent.UseTicketTypeTemplate === 1 ? 'invert(1)' : ''}} 
                  src={ chosedTicketTypes.includes(tkt) ? small_checkmark : small_square
                    
                  } 
                  alt="checkmark" />
                   <p  style={{padding:0,margin:0}}>{tkt.Name}</p>
                { tktDetailShown === true ? <>
                   <p  style={{padding:0,margin:0,}}>
                     {tkt.WebBuy  === 1 && tkt.WebReserve === 0 ? 'Køb'  : ''}
                     {(tkt.WebBuy === 1) && (tkt.WebReserve === 1) ? 'Køb&Bestil' : ''}
                      {tkt.WebReserve === 1 && tkt.WebBuy === 0 ? 'Bestil' : ''}</p>
                   <p  style={{padding:0,margin:0,}}>
                    {tkt.BundleCount > 0 ? tkt.BundleCount+'stk' : ''}</p>
                     {tkt.Hide === 0 ? <img src={eye} alt='eye' /> : <p></p>}           
                   <p  style={{paddingLeft:'8px',margin:0,width:'50px'}}>
                     {calculatePrice(tkt)}
                     </p>
                     </> : ''}
                     { checkForAlertonChosen(tkt) === true &&  <img style={{}} src={alertIcon} alt='alert-icon' />}
                   </div>
                ))
                : 
                allTicketTypes.sort((a, b) =>
  a.Name.localeCompare(b.Name, undefined, { sensitivity: "base" })
)
                .slice(slide === 0 ? 0 :  tktDetailShown === true ? slide*50 : 
                       slide*100                    ,
                     slide === 0 ? 25 : tktDetailShown === true ? 
                slide*50+25 : slide * 100+25).map((tkt,index) => (                               
                  <>        
             <span style={{position:'absolute', left:slide*100+index+1 > 99 ? '8px': '8px',fontSize:'12px',color:'rgba(70,72,76,0.5',border:'1px ',textAlign:'right',width:slide*100+index+1 > 99 ? '20px':'20px',marginTop:'0px'}}>
              {slide === 0  ? index+1 : tktDetailShown === true ?
               slide*50+index+1 : slide*100+index+1}</span>
              <div key={index} style={{display:'grid',
                gridTemplateColumns:tktDetailShown === true ? '0.1fr 0.7fr .4fr .4fr .2fr .3fr .1fr' : '.11fr 1fr .1fr',fontSize:'12px',height:'18px',padding:'0px'}}
                 onClick={()=> theEvent.UseTicketTypeTemplate === 0 ?  handleChosenTicketSelect(tkt) : ''}>

                  <img style={{padding:'2px',filter: theEvent.UseTicketTypeTemplate === 1 ? 'invert(1)' : ''}} 
                  src={ chosedTicketTypes.includes(tkt) ? small_checkmark : small_square
                   
                  } 
                  alt="checkmark" />
                  
                  <p className='text_elip' style={{padding:'0',margin:0,width:'133px'}}>{tkt.Name}</p>
                  {tktDetailShown === true ? <> 
                  <p  style={{padding:'0 0 0 0px',margin:0,}}>
                    {tkt.WebBuy  === 1 && tkt.WebReserve === 0 ? 'Køb'  : ''}
                    {(tkt.WebBuy === 1) && (tkt.WebReserve === 1) ? 'Køb&Bestil' : ''}
                    {tkt.WebReserve === 1 && tkt.WebBuy === 0 ? 'Bestil' : ''} 
                     
                  </p>
                   <p  style={{padding:0,margin:0,paddingLeft:'0px'}}>
                    {tkt.BundleCount > 0 ? tkt.BundleCount+' stk' : 'Ikke muligt'}</p>
                    {tkt.Hide === 0 ? <img src={eye} alt='eye' /> : <p></p>}
                 
                  
                  <p  style={{padding:0,margin:0,textAlign:'center',width:'50px'}}> {calculatePrice(tkt)}</p>                              
</> : ''}

                     { theEvent.UseTicketTypeTemplate === 0 ? 
                      checkForAlertonChosen(tkt) === true || checkForAlertonNotChosen(tkt) === true ?  
                  <img style={{marginTop:'2px'}} src={alertIcon} alt='alert-icon' /> : '' 
                  : ''
                  }
                  </div>
                  </>
                 )
                )
              }        
      </div>
                 </div>  
                 
          {/* div 2 */}
          { !b.length && (allTicketTypes.length > (slide === 0 ?  25 : tktDetailShown === true ? slide*50+25 : slide*100+25 )) ?
             <div style={{position:'relative',marginRight:'35px'}}>
                 <div style={{display:'grid',width:tktDetailShown === true ? '500px' : '250px',fontSize:'12px',fontWeight:'bold',marginTop:'20px',     gridTemplateColumns:tktDetailShown === true ? '0.82fr .4fr .4fr .23fr .2fr' : '.1fr 1fr',height:'20px',letterSpacing:'0.24px'}}>
                   <p style={{fontWeight:'bold',paddingLeft:'0px'}}>Tilføjet </p>
                   { tktDetailShown === true ?
                   <>
                   <p style={{fontWeight:'bold',width:'54px'}}>Website</p>
                   <p style={{fontWeight:'bold'}}>Bundlesalg</p>
                   <img style={{paddingRight:'20px'}} src={eye} alt="" />
                   <p style={{fontWeight:'bold'}}>Pris kr.</p> </>
                   : ''}
                </div>
             
                <div style={{border:'1px solid #8b8b8b',width:tktDetailShown === true ?'545px' : '250px',height:'462px',marginBottom:'0px',backgroundColor:'white',overflow:'auto',padding:'5px'}}>
                  
                 
            {    allTicketTypes.sort((a, b) =>
  a.Name.localeCompare(b.Name, undefined, { sensitivity: "base" })
)
                 .slice(slide === 0 ?  25 : tktDetailShown === true ?  slide*50+25 : slide *100+25, slide === 0 ?  50 : tktDetailShown === true ?  slide*50+50 :  slide*100+50).map((tkt,index) => {
                 tktCount =   slide*100+index+26
           return    <>
            
                <span style={{position:'absolute', left : '-22px',fontSize:'12px',color:'rgba(70,72,76,0.5',border:'1px ',textAlign:'right',width:slide*100+index+26 > 99 ? '20px':'20px',marginTop:'0px'}}>
                  {slide === 0 ? index+26 : tktDetailShown === true ?  slide*50+index+26 : slide*100+index+26}
                  </span>

                <div key={index} style={{display:'grid',
                  gridTemplateColumns: tktDetailShown === true ? '0.1fr 0.7fr .4fr .4fr .2fr .3fr .1fr' : '.11fr 1fr .1fr',fontSize:'12px',height:'18px',padding:'0px',border:'1px '}} onClick={() => theEvent.UseTicketTypeTemplate === 0 ?   handleChosenTicketSelect(tkt) : ''}>

                    <img style={{padding:'2px',filter: theEvent.UseTicketTypeTemplate === 1 ? 'invert(1)' : ''}} 
                    src={ chosedTicketTypes.includes(tkt) ? small_checkmark : small_square
                   
                  }  alt="checkmark" />

                  <p className='text_elip' style={{padding:'0',margin:0,width:'133px'}}>{tkt.Name}</p>
                  {tktDetailShown === true ? <> 
                  <p  style={{padding:'0 0 0 0px',margin:0,}}>
                    {tkt.WebBuy  === 1 && tkt.WebReserve === 0 ? 'Køb'  : ''}
                    {(tkt.WebBuy === 1) && (tkt.WebReserve === 1) ? 'Køb&Bestil' : ''}
                    {tkt.WebReserve === 1 && tkt.WebBuy === 0 ? 'Bestil' : ''} 
                     
                  </p>
                  <p  style={{padding:0,margin:0,paddingLeft:'0px'}}>
                    {tkt.BundleCount > 0 ? tkt.BundleCount+' stk' : 'Ikke muligt'}</p>
                    
                      {tkt.Hide === 0 ? <img src={eye} alt='eye' /> : <p></p>}
                                       
                  <p  style={{padding:0,margin:0,textAlign:'center',width:'50px'}}> {calculatePrice(tkt)}</p>
                               
                  </> : ''}
                  { theEvent.UseTicketTypeTemplate === 0 ? 
                      checkForAlertonChosen(tkt) === true || checkForAlertonNotChosen(tkt) === true ?  
                  <img style={{}} src={alertIcon} alt='alert-icon' /> : '' 
                  : ''
                  }
                 
                  </div>
                  </>
                 }
                )} 
                     
      </div>
             </div>                                                         
             : ''}
         {/* div 3 and div 4  ONLY VISIBLE WHEN TKTDETAILSSHOWN IN FALSE*/}
           { tktDetailShown === false && !b  && tktCount < allTicketTypes.length?
           <>
           {(allTicketTypes.length > (slide === 0 ?  50  : slide*100+25 )) && 
          //  numberOfSlides[slide] === slide && 
           <div style={{position:'relative',marginRight:'35px'}}>
            <div style={{display:'grid',gridTemplateColumns:'1 fr',fontSize:' 12px',fontWeight:'bold',marginTop:'20px',height:'20px',letterSpacing:'0.24px'}}>
                <p>Tilføjet 3 </p>
            </div>
            <div style={{border:'1px solid #8b8b8b',
                    width: '250px',height:'463px',marginBottom:'0px',backgroundColor:'white',overflow:'auto',padding:'5px'}}>
                       {
                allTicketTypes.sort((a, b) =>
  a.Name.localeCompare(b.Name, undefined, { sensitivity: "base" })
)
                .slice(slide === 0 ? 50 : slide*100+50, slide === 0 ? 50+25 : slide*100+75).map((tkt,index) => {
                  tktCount =  slide*100+index+1+50
           return   <>
             
             <span style={{position:'absolute', left:  '-22px',fontSize:'12px',color:'rgba(70,72,76,0.5',border:'1px ',textAlign:'right',width:'15px',marginTop:'0px'}}>{slide === 0 ? 50+index+1 : slide*100+index+1+50}</span>
              <div key={index} style={{display:'grid',
                gridTemplateColumns:'.11fr 1fr .1fr',fontSize:'12px',height:'18px',padding:'0px'}} 
                onClick={() => theEvent.UseTicketTypeTemplate === 0 ?  handleChosenTicketSelect(tkt) : ''}>
                  <img style={{padding:'2px',filter: theEvent.UseTicketTypeTemplate === 1 ? 'invert(1)' : ''}} 
                  src ={chosedTicketTypes.includes(tkt) ? small_checkmark : small_square  }  alt ="checkmark" />

                  <p className='text_elip' style={{padding:'0',margin:0,width:'133px'}}>{tkt.Name}</p>
                 
                 
                  { theEvent.UseTicketTypeTemplate === 0 ? 
                      checkForAlertonChosen(tkt) === true || checkForAlertonNotChosen(tkt) === true ?  
                  <img style={{}} src={alertIcon} alt='alert-icon' /> : '' 
                  : ''
                  }
  
                  </div>
                  </>
                }
                )
              }     
                    </div>
           </div>
          }
          {(allTicketTypes.length > (slide === 0 ?  50 : tktDetailShown === true ? slide*50+25 : slide*100+25 ))  && numberOfSlides[slide] === slide &&  tktCount < allTicketTypes.length &&
           <div  style={{position:'relative',marginRight:'35px'}}>
            <div style={{display:'grid',gridTemplateColumns:'1 fr',fontSize:' 12px',fontWeight:'bold',marginTop:'20px',height:'20px',letterSpacing:'0.24px'}}>
                <p>Tilføjet 4</p>
            </div>
            <div style={{border:'1px solid #8b8b8b',
                    width: '250px',height:'463px',marginBottom:'0px',backgroundColor:'white',overflow:'auto',padding:'5px'}}>
                       {
                allTicketTypes.sort((a, b) =>
  a.Name.localeCompare(b.Name, undefined, { sensitivity: "base" })
)
                .slice( slide === 0 ? 75 : slide*100+75 ,slide === 0 ? 75+25 : slide*100+100).map((tkt,index) => {
                  tktCount = slide*100+index+1+75
           return   <>
             
             <span style={{position:'absolute', left:  '-22px',fontSize:'12px',color:'rgba(70,72,76,0.5',border:'1px ',textAlign:'right',width:'20px',marginTop:'0px'}}>{slide === 0 ? 75+index+1 : tktDetailShown === true ?  slide*50+index+1 : slide*100+index+1+75}</span>
              <div key={index} style={{display:'grid',
                gridTemplateColumns:'.11fr 1fr .1fr',fontSize:'12px',height:'18px',padding:'0px'}} 
                onClick={(e) =>theEvent.UseTicketTypeTemplate === 0 ?  handleChosenTicketSelect(e,tkt) : ''}>
                  <img style={{padding:'2px',filter:theEvent.UseTicketTypeTemplate === 1 ? 'invert(1)':''}} 
                  src={chosedTicketTypes.includes(tkt) ? small_checkmark : small_square  }  alt="checkmark" />

                  <p className='text_elip' style={{padding:'0',margin:0,width:'133px'}}>{tkt.Name}</p>
                 
                 
                  { theEvent.UseTicketTypeTemplate === 0 ? 
                      checkForAlertonChosen(tkt) === true || checkForAlertonNotChosen(tkt) === true ?  
                  <img style={{}} src={alertIcon} alt='alert-icon' /> : '' 
                  : ''
                  }
 
                  </div>
                  </>
                }
                )
              }     
                    </div>
           </div>
          }
           </>
            : ''}  
              </div> 
        { tktDetailShown === true ? 
          <div style={{border:'1px ', display:'flex',margin:'30px',  justifyContent:'space-between'}}>

             <button className='prev' disabled={slide=== 0 ?true:false} style={{opacity:slide=== 0  ? '0.5':'1', }} onClick={(e) => { backSlide(e)}}>❮ forrige billettyper</button>
             <p style={{paddingTop:'10px',fontSize:'12px',letterSpacing:'0.24px',color:'#46484c'}}>
              viser {slide === 0 ? '1' : slide*50+1} - {slide === 0 && allTicketTypes.length > 50 ? 50 : slide+1 === numberOfSlides.length ? allTicketTypes.length : slide*50+50 } ud af i alt {allTicketTypes.length}  billettyper </p>
             <button className='next' disabled={ slide === numberOfSlides.slice(-1)[0] ? true : false} style={{opacity: slide === numberOfSlides.slice(-1)[0] ? '0.5':'1', }} onClick={(e) => { nextSlide(e)}}>næste billettyper ❯              
             </button>

          </div>
          : 
          <div style={{border:'1px ', display:'flex',margin:'30px',justifyContent:'space-between'}}>
             <button className='prev' disabled={slide=== 0 ?true:false} style={{opacity:slide=== 0  ? '0.5':'1', }}  onClick={(e) => { backSlide(e)}}>❮ forrige billettyper</button>
             <p style={{paddingTop:'10px',fontSize:'12px',letterSpacing:'0.24px',color:'#46484c'}}>
              viser {slide === 0 ? '1' : slide*100+1} - 
              {slide === 0 && allTicketTypes.length > 100 ? 100 
              // : (slide+1)*2 === numberOfSlides.length ? allTicketTypes.length 
               : slide+1 === numberOfSlides.length ? allTicketTypes.length 
              : slide*100+100 } {''} 
              ud af i alt {allTicketTypes.length}  billettyper </p>
             <button className='next' disabled={
               slide === four_row_slides.slice(-1)[0]
              
              } 
              
               onClick={(e) => {nextSlide(e)}}>næste billettyper ❯</button>
          </div>
          }
         </div>
    </>
               

))}


               </div>  
               {/* slideshow container ends in above div */}
               </div> 
              
              </div>
              </section>
              </div> 
 </div>
   </Modal>  
        
        ) : null
             }

  

export default EditModal